import { create } from 'zustand';
import { UserRolesType } from '../api/types';

type GlobalStore = {
  user?: {
    first_name: string;
    last_name: string;
    name?: string;
    email?: string;
    companyName?: string;
    id?: string;
    deviceToken?: string;
    isGrantedAccessToMbPortal?: boolean;
    userType?: string;
    roles?: UserRolesType[];
    'custom:roles'?: string;
    brokerageId?: string;
    externalId?: string;
  }
  company?: {
    name?: string;
    logo?: string;
    primary_color?: string;
    id: number;
  }
  isLoggedIn: boolean;
  canFetchFeatureConfiguration: boolean;
  setCanFetchFeatureConfiguration: (setCanFetchFeatureConfiguration: GlobalStore['canFetchFeatureConfiguration']) => void;
  setUser: (user: GlobalStore['user']) => void;
  setCompany: (company: GlobalStore['company']) => void;
  setIsLoggedIn: (isLoggedIn: GlobalStore['isLoggedIn']) => void;
  credits: {
    isOpenedBuyCredits: boolean;
    creditsToSpend?: number;
  };
  setIsOpenedBuyCredits: (isOpened: boolean) => void;
  setBuyCreditsToSpend: (amount: number) => void;
};

export const useGlobalStore = create<GlobalStore>((set) => ({
  setUser: (user) => set(() => ({ user })),
  setCompany: (company) => set(() => ({ company })),
  setIsLoggedIn: (isLoggedIn) => set(() => ({ isLoggedIn })),
  isLoggedIn: true,
  setCanFetchFeatureConfiguration: (canFetchFeatureConfiguration) => set(() => ({ canFetchFeatureConfiguration })),
  canFetchFeatureConfiguration: false,
  credits: { isOpenedBuyCredits: false, creditsToSpend: 0 },
  setIsOpenedBuyCredits: (isOpened: boolean) => set((store) => ({
    credits: {
      ...store.credits,
      isOpenedBuyCredits: isOpened,
    },
  })),
  setBuyCreditsToSpend: (amount: number) => set((store) => ({
    credits: {
      ...store.credits,
      creditsToSpend: amount,
    },
  })),
}));

type LayoutStore = {
  headerContent: React.ReactNode | null;
  asideContent: React.ReactNode | null;
  setHeaderContent: (content: React.ReactNode) => void;
  setAsideContent: (content: React.ReactNode) => void;
};

export const useLayoutStore = create<LayoutStore>((set) => ({
  asideContent: null,
  headerContent: null,
  setAsideContent: (asideContent) => set(() => ({ asideContent })),
  setHeaderContent: (headerContent) => set(() => ({ headerContent })),
}));
